import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from '@mui/material';
import { formatPhoneNumber } from '../../../../helpers/formatters';

const ShowContactInfoDialog = ({ siteRole, handleClose, data = [], isOpen = false }) => (
  <Dialog onClose={handleClose} open={isOpen}>
    <DialogTitle sx={{ textAlign: 'center' }}>{siteRole} contact information</DialogTitle>
    <DialogContent>
      <ul>
        {data.map((contact) => (
          <li key={contact.id}>
            <Typography key={contact.name} sx={{ marginBottom: 1, marginTop: 1 }}>
              {contact.firstname} {contact.lastname}{' '}
              <Link href={`tel:${contact.phone}`} underline="hover">
                {formatPhoneNumber(contact.phone)}
              </Link>{' '}
              <Link href={`mailto: ${contact.email}`} underline="hover">
                {contact.email}
              </Link>
            </Typography>
          </li>
        ))}
      </ul>
    </DialogContent>
    <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
      <Button onClick={handleClose} variant="contained" color="primary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default ShowContactInfoDialog;
